import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { useGoToEventTab } from "../useGoToEventTab";
import { deriveNowPanel, type NowActionTarget } from "./deriveNowPanel";
import { NowPanel } from "./NowPanel";
import { useNowPanelData } from "./useNowPanelData";

export const EventNowPanel = ({ event }: { event: SourcingEventV2Dto }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const navigate = useNavigate();
  const goToTab = useGoToEventTab();
  const state = deriveNowPanel(useNowPanelData(event));

  if (state == null) return null;
  const { action } = state;

  const go = (target: NowActionTarget) => {
    if (target.kind === "tab") goToTab(target.tab, target.subTab);
    else navigate(target.url);
  };

  return (
    <NowPanel
      status={t(state.status.key, {
        ...state.status.params,
        ...(state.status.dateIso ? { date: displayDate(state.status.dateIso) } : {}),
      })}
      detail={state.detail.map((segment) => t(segment.key, segment.params ?? {})).join(". ") || undefined}
      progress={state.progress}
      action={action && { label: t(action.labelKey), onClick: () => go(action.target) }}
    />
  );
};
